<template>
  <div>
    <h2>予約一覧</h2>
    <BookingList
      v-if="bookingConnection && bookingConnection.edges.length > 0"
      :booking-connection="bookingConnection"
      :is-loading="calendarBookingsQueryLoading"
      @click-load-more="onClickLoadMore"
    />
    <div
      v-else-if="!calendarBookingsQueryLoading"
      :class="$style.bookingListWrapper__notFound"
    >
      このカレンダーにはまだ予約はありません
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useFetchCalendarBookingsByCalendarGuidQuery } from './CalendarBookings.generated.ts'
import BookingList from '@/components/organisms/BookingList/BookingList.vue'
import { useAlert } from '@/libs/alertPortal/index.ts'

const props = defineProps<{
  calendarGUID: string
}>()

const {
  fetchMore: calendarBookingsQueryFetchMore,
  result: calendarBookingsQueryResult,
  loading: calendarBookingsQueryLoading,
} = useFetchCalendarBookingsByCalendarGuidQuery(
  {
    guid: props.calendarGUID,
    first: 20,
  },
  { fetchPolicy: 'no-cache' }
)

const alert = useAlert()

const bookingConnection = computed(() => {
  return calendarBookingsQueryResult.value?.calendarDetail.__typename ===
    'CalendarDetailSuccess'
    ? calendarBookingsQueryResult.value?.calendarDetail.calendar.bookings
    : undefined
})

const onClickLoadMore = async (after: string | null) => {
  try {
    await calendarBookingsQueryFetchMore({
      variables: {
        after,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (
          fetchMoreResult?.calendarDetail.__typename !==
            'CalendarDetailSuccess' ||
          previousResult.calendarDetail.__typename !== 'CalendarDetailSuccess'
        ) {
          return previousResult
        }
        const newEdges = fetchMoreResult?.calendarDetail.calendar.bookings.edges
        const pageInfo =
          fetchMoreResult?.calendarDetail.calendar.bookings.pageInfo

        return newEdges?.length && pageInfo
          ? {
              ...previousResult,
              calendarDetail: {
                ...previousResult.calendarDetail,
                calendar: {
                  bookings: {
                    edges: [
                      ...previousResult.calendarDetail.calendar.bookings.edges,
                      ...newEdges,
                    ],
                    pageInfo,
                  },
                },
              },
            }
          : previousResult
      },
    })
  } catch (e) {
    console.error(e)
    alert.error('エラーが発生しました。再度お試しください。')
  }
}
</script>

<style lang="scss" module>
.bookingListWrapper {
  margin-top: 8px;

  &__notFound {
    padding: 24px;
    text-align: center;
    color: $color-text-and-object-low-emphasis;
  }
}
</style>
